import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getAutoInvestContracts: () => ({
    url: 'DirectDebit/api/v1/AutoInvest/Contracts/GetUserContracts',
    method: 'GET',
  }),
  getChildAutoInvestContracts: (input) => ({
    url: 'DirectDebit/api/v1/AutoInvest/Child/Contracts',
    method: 'GET',
    params: input,
  }),
  getAutoInvestBaseInfos: () => ({
    url: 'DirectDebit/api/v1/AutoInvest/BaseInfos/GetBaseInfos',
    method: 'GET',
  }),
  getAutoInvestDestinationFunds: () => ({
    url: 'DirectDebit/api/v1/AutoInvest/funds/GetFundList',
    anonymousUrl: 'DirectDebit/Anonymous/api/v1/AutoInvest/funds',
    method: 'GET',
  }),

  getAutoInvestTransactionsByContract: (input) => ({
    url: 'DirectDebit/api/v1/AutoInvest/Transaction/Contract',
    method: 'GET',
    params: input,
  }),
  getUsersAutoInvestTransactions: (input) => ({
    url: 'DirectDebit/api/v1/AutoInvest/Transaction',
    method: 'GET',
    params: input,
  }),
  getChildAutoInvestTransactions: (input) => ({
    url: 'DirectDebit/api/v1/AutoInvest/Child/Transactions',
    method: 'GET',
    params: input,
  }),
  getAutoInvestLicenseDetail: (input) => ({
    url: `DirectDebit/api/v1/AutoInvest/DirectDebit/${input.trackingId}`,
    method: 'GET',
  }),
  cancelDirectDebitSchedule: (input) => ({
    url: 'DirectDebit/api/v1/AutoInvest/Contracts/Delete',
    method: 'DELETE',
    params: input,
  }),
  getAutoInvestScheduleDetail: (input) => ({
    url: `DirectDebit/api/v1/AutoInvest/Contracts/GetUserContract/${input.trackingId}`,
    method: 'GET',
  }),
  getAutoInvestCalendar: (input) => ({
    url: 'DirectDebit/api/v1/AutoInvest/Contracts/User/Calendar',
    method: 'GET',
    params: input,
  }),
  DeleteAutoInvestLicense: (input) => ({
    url: `DirectDebit/api/v1/AutoInvest/DirectDebit/${input?.id}`,
    method: 'DELETE',
  }),
  ValidateAutoInvestInfo: (input) => ({
    url: 'DirectDebit/api/v1/AutoInvest/Contracts/Validation',
    method: 'POST',
    data: input,
  }),
  getAutoInvestTransactionDetails: (input) => ({
    url: `DirectDebit/api/v1/AutoInvest/Transaction/${input.trackingId}`,
    method: 'GET',
  }),
  getAutoInvestFeatureToggle: () => ({
    url: 'DirectDebit/api/v1/AutoInvest/BaseInfos/FeatureToggle',
    method: 'GET',
  }),
  renewalAutoInvestDirectDebit: (input) => ({
    url: 'DirectDebit/api/v1/AutoInvest/DirectDebit/Renewal',
    method: 'POST',
    data: input,
  }),
  renewalAutoInvestUserContract: (input) => ({
    url: `directDebit/api/v1/autoInvest/contracts/user/${input.trackingId}/renewal`,
    method: 'POST',
  }),
  getUserContractFund: (input) => ({
    url: `DirectDebit/api/v1/AutoInvest/Contracts/GetUserContractFund/${input.fundCode}`,
    method: 'GET',
  }),
};

export default apis;
